import { handleActions, createAction } from 'redux-actions';
import { keyBy, orderBy } from 'lodash';

import {
  createAsyncTypes,
  createAsyncActions,
  createType
} from '../../commons/util/reduxAsync';

const stateKey = 'solicitacoes';

// domain specif constants
export const consts = {
  STATUS_SOLICITACAO: {
    EM_ANDAMENTO: 'EM_ANDAMENTO',
    FINALIZADA: 'FINALIZADA'
  }
};

// action types
export const types = {
  GET_PENDENCIAS: createAsyncTypes(stateKey, 'GET_PENDENCIAS'),
  GET_CONCLUIDAS: createAsyncTypes(stateKey, 'GET_CONCLUIDAS'),
  GET_BYID: createAsyncTypes(stateKey, 'GET_BYID'),
  RESET_LIST: createType(stateKey, 'RESET_LIST')
};

// actions
export const actions = {
  getSolicitacoesPendentes: createAsyncActions(types.GET_PENDENCIAS),
  getSolicitacoesConcluidas: createAsyncActions(types.GET_CONCLUIDAS),
  getSolicitacao: createAsyncActions(types.GET_BYID),
  resetSolicitacoes: createAction(types.RESET_LIST)
};

// reducer
const initialState = {
  estatisticas: {
    status: {
      EM_ANDAMENTO: 0,
      FINALIZADA: 0
    }
  },
  byId: {},
  allIdsByStatus: {
    EM_ANDAMENTO: [],
    FINALIZADA: []
  }
};

export default handleActions(
  {
    [types.GET_PENDENCIAS.SUCCESS]: (state, { payload }) => {
			if (!payload.solicitacoes) return state;

			const solicitacoes = orderBy(payload.solicitacoes, [
				'requerida',
				'criacao'
			], ['desc', 'desc'])

      return {
        ...state,
        estatisticas: payload.estatisticas,
        byId: { ...state.byId, ...keyBy(solicitacoes, 'chave') },
        allIdsByStatus: {
          ...state.allIdsByStatus,
          EM_ANDAMENTO: solicitacoes.map((s) => s.chave)
        }
      };
    },
    [types.GET_CONCLUIDAS.SUCCESS]: (state, { payload }) => {
      if (!payload.solicitacoes) return state;

      return {
        ...state,
        estatisticas: payload.estatisticas,
        byId: { ...state.byId, ...keyBy(payload.solicitacoes, 'chave') },
        allIdsByStatus: {
          ...state.allIdsByStatus,
          FINALIZADA: orderBy(
            payload.solicitacoes,
            ['finalizacao'],
            ['desc']
          ).map((s) => s.chave)
        }
      };
    },
    [types.GET_BYID.SUCCESS]: (state, { payload }) => ({
      ...state,
      byId: {
        ...state.byId,
        [payload.chave]: {
          ...payload,
          interacoes: payload.interacoes
            ? orderBy(payload.interacoes, ['criacao'], ['desc'])
            : [],
          documentos: payload.documentos
            ? orderBy(payload.documentos, ['criacao'], ['desc'])
            : []
        }
      }
    }),
    [types.RESET_LIST]: () => ({
      ...initialState
    })
  },
  initialState
);

// selectors
const getEstatisticas = (state) => state[stateKey].estatisticas;
const getEstatisticaByStatus = (state, status) =>
  getEstatisticas(state).status[status];
const hasSolicitacao = (state) => {
  const { status } = getEstatisticas(state);
  return status.EM_ANDAMENTO > 0 || status.FINALIZADA > 0;
};
const getSolicitacoesByStatus = (state, status) =>
  state[stateKey].allIdsByStatus[status].map((id) => state[stateKey].byId[id]);
const getSolicitacaoById = (state, chave) => {
  const solicitacao = state[stateKey].byId[chave] || {};
  return {
    ...solicitacao,
    interacoes: solicitacao.interacoes
      ? solicitacao.interacoes.filter((i) =>
        ['EM_ANDAMENTO', 'FINALIZADA'].includes(i.status)
      )
      : [],
    documentos: solicitacao.documentos ? solicitacao.documentos : []
  };
};

export const selectors = {
  getEstatisticas,
  getEstatisticaByStatus,
  hasSolicitacao,
  getSolicitacoesByStatus,
  getSolicitacaoById
};
